import React from "react";
import PropTypes from "prop-types";
import { FlexContainer } from "BaseComponents/Flex";
import styled from "styled-components";
import { Paragraph } from "BaseComponents/Text";
import { PrimaryButton, ButtonText } from "Buttons";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

const Wrapper = styled(FlexContainer)`
	flex-basis: 50%;
	flex-direction: column;
	flex-grow: 1;
	background-color: ${({ theme }) => theme.colors.lightgrey};
	margin-top: 1rem;
	height: initial;

	${media.greaterThan(breakpoints.mobile)`
    flex-basis: 30%;
    background-color: ${({ theme }) => theme.colors.white};
    margin-top: 0;
  `}
`;

const TextWrapper = styled.div`
	text-align: center;
	max-width: 370px;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
`;

const Text = styled(Paragraph)`
	line-height: 26px;
	text-align: center;
	margin-bottom: auto;
`;

const Icon = styled.img`
	margin-bottom: 1rem;
	max-height: 5rem;

	${media.greaterThan(breakpoints.ipad)`
		height: 5rem;
	`}
`;
const HeaderH2 = styled.h2`
	font-size: 20px;
	line-height: 26px;
	margin: ${({ margin }) => (margin ? margin : "")};
	${media.greaterThan(breakpoints.ipad)`
	font-size: 24px;
		line-height: 30px;
	`}
`;

export const Puff = ({ ListHeadline, ListIcon, Url, ListPreamble, ListButtonHeading }) => {
	return (
		<Wrapper
			smallpadding="2rem 10px"
			smallwidth="auto"
			alignItems="center"
			smallAlignContent="center"
			minwidth="200px"
		>
			<TextWrapper>
				{ListIcon.length > 0 && <Icon alt="" src={ListIcon} />}
				<HeaderH2 fontSize="24px" margin="0 0 1rem 0">
					{ListHeadline}
				</HeaderH2>
				<Text large>{ListPreamble}</Text>
				<PrimaryButton wide href={Url} margin="2rem 0 0 0" ariaLabel={ListHeadline}>
					<ButtonText heading={ListHeadline}>{ListButtonHeading}</ButtonText>
				</PrimaryButton>
			</TextWrapper>
		</Wrapper>
	);
};

Puff.propTypes = {
	ListHeadline: PropTypes.string,
	ListIcon: PropTypes.string,
	Url: PropTypes.string,
	ListPreamble: PropTypes.string,
	ButtonAriaLabel: PropTypes.string,
	ListButtonHeading: PropTypes.string,
};
